<template>
    <div class="scrollable login-page giris" style="margin: 0 !important;">
       <div class="siparisdetay-content">
            
            <div class="dashboardButonKonum">
                <el-tooltip class="item" effect="dark" :content="$t('gunlukRapor.routeSiparis')" placement="right">
                    <button class="ozelButon yeni card-shadow--medium" @click="routeSiparis" style="cursor: pointer;width: 50px;height: 50px !important">
                        <i class="mdi mdi-home mdi-36px"></i>
                    </button>
                </el-tooltip>
            </div>

            <el-row type="flex" justify="center">
                <el-radio-group class="siparisRadio" v-model="tarihSecim" @change="changeTarih">
                    <el-radio-button label="0">{{$t('gunlukRapor.dun')}}</el-radio-button>
                    <el-radio-button label="1">{{$t('gunlukRapor.bugun')}}</el-radio-button>
                </el-radio-group>
            </el-row>

            <el-row class="mt-10">
                <div v-if="orders.length > 0" v-loading="loading || deleteLoading"
                :element-loading-text="loading ? $t('gunlukRapor.yukleniyor') : $t('gunlukRapor.siliniyor')"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 1)">
                    <el-table :data="orders" style="width: 100%" border stripe>
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <div v-if="props.row.detay.length > 0" style="font-size: 13px !important">
                                    <p><b> {{$t('siparis.siparisDetay')}} </b></p>
                                    <ul class="malzeme-detay">
                                        <li v-for="(item, index) in props.row.detay" :key="index">
                                            <span>{{item.urunAdi}}</span>
                                            <ul  v-if="item.malzeme.length > 0">
                                                <li v-for="(item, index) in item.malzeme" :key="index">{{item.malzemeAdi}}</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('gunlukRapor.siparisID')"
                            prop="msiparisId"
                            width="auto">
                        </el-table-column>
                        <el-table-column
                            :label="$t('gunlukRapor.siparisTarihi')"
                            prop="siparisTarihi"
                            width="auto">
                        </el-table-column>
                        <el-table-column
                            :label="$t('gunlukRapor.siparisYeri')"
                            prop="siparisYeri"
                            width="auto">
                        </el-table-column>
                        <el-table-column
                            :label="$t('gunlukRapor.odemeSekli')"
                            prop="odemeSekli"
                            width="auto">
                            <template slot-scope="props">
                                <p v-if="props.row.odemeSekli == '1'"> {{$t('siparis.nakit')}} </p>
                                <p v-if="props.row.odemeSekli == '2'"> {{$t('siparis.kart')}} </p>
                                <p v-if="props.row.odemeSekli == '3'"> {{$t('siparis.ucretsiz')}} </p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('gunlukRapor.toplamFiyat')"
                            prop="toplamFiyat"
                            width="auto">
                        </el-table-column>
                        <el-table-column
                            :label="$t('gunlukRapor.siparisTuru')"
                            prop="tur"
                            width="auto">
                            <template slot-scope="props">
                                <p v-if="props.row.tur == '0'">{{$t('siparis.icSiparis')}}</p>
                                <p v-else-if="props.row.tur == '1'">{{$t('siparis.disSiparis')}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('gunlukRapor.islem')"
                            width="80"
                            fixed="right"
                            align="center">
                            <template slot-scope="props">
                                
                                <el-tooltip effect="dark" :content="$t('gunlukRapor.siparisSil')" placement="right">
                                    <el-button @click="deleteOrder(props.row, props.$index)" icon="el-icon-delete">
                                    </el-button>
                                </el-tooltip>

                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div v-else class="siparis-yok">
                    <b>{{$t('gunlukRapor.siparisYok')}}</b>
                </div>

                <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
                </el-pagination>
            </el-row>

       </div>
    </div>
</template>

<script>
    import musteriService from '../WSProvider/MusteriService';
    import moment from 'moment-timezone'
    import notification from "../notification";

    let base64 = require('base64_js');
    export default {
        name: 'Sevkiyat',
        data() {
            return {
                loading: false,
                deleteLoading: false,
                orders: [],
                tarihSecim: "1",
                tarih: "",

                page: 0,
                sizes: 10,
                postPage: 0,
                total: null,
            }
        },
        mounted() {
            if (localStorage.getItem("userDataKaderFoodKasa")) {
                var userDataKaderFoodKasa = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKaderFoodKasa"))));
                this.tarih = moment(moment().toDate()).format("YYYY-MM-DD");
                this.getDailyOrders();
            } else {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            }
        },
        methods: {
            devamEt() {
                this.$store.commit('changeSevkiyat', this.form);
                this.$router.push({name: 'siparis'})
            },

            routeSiparis() {
                this.$router.push({name: 'dashboard'})
            },

            deleteOrder(selection, index){
                musteriService.musteriSiparisSil(selection.msiparisId).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, this.$t('bildirim.siparisSilBasarili'));
                        this.orders.splice(index, 1);
                    } else notification.Status(response.status, this)
                });
            },

            getDailyOrders(){
                this.loading = true;
                musteriService.tarihliSiparisListe(this.tarih, this.tarih, this.postPage, this.sizes,).then(response => {
                    if(response.status == 200){
                        this.orders = response.data;
                        this.total = response.siparisSayisi;
                    }
                    this.loading = false;
                }).catch(e => {
                    this.loading = false;
                })
            },

            changeTarih(val){
                if(val == '0') this.tarih = moment(moment().subtract(1, 'days').toString()).format("YYYY-MM-DD");
                else if(val == '1') this.tarih = moment(moment().toDate()).format("YYYY-MM-DD");
                this.getDailyOrders();
            },


            handleSizeChange(val) {
                this.sizes = val;
                this.getDailyOrders();
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getDailyOrders();
            },
        }
    }
</script>

<style lang="scss">
    @import '../assets/scss/_variables';

    .giris {
        background-image: url("../assets/images/katman/giris-bg.jpg") !important;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: 100%;
        width: 100%;
        margin: 0 -30px;

        .siparisdetay-content{
            margin-top: 3%;
            padding: 10px 30px;
        }

        .el-pagination.is-background .el-pager li:not(.disabled).active{
            background-color: #00933e;
        }
    }

    .login-page {
        background: $text-color;
        margin-left: -30px;
        margin-right: -30px;

    }

    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .siparisRadio {
        width: 100%;
    }

    .siparisRadio .el-radio-button {
        width: calc(100% / 2)
    }

    .siparisRadio .el-radio-button__inner:hover {
        color: #00933e;
    }
    
    .siparisDurumRadio .el-radio-button__inner:hover {
        color: #00933e;
    }

    .siparisRadio .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #00933e;
        border-color: #00933e;
    }

    .siparisDurumRadio .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #00933e;
        border-color: #00933e;
    }

    .siparisRadio .el-radio-button__orig-radio:checked + .el-radio-button__inner:hover {
        color: #ffffff;
    }
    
    .siparisDurumRadio .el-radio-button__orig-radio:checked + .el-radio-button__inner:hover {
        color: #ffffff;
    }

    .siparis-yok{
        width: 100%;
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
    }

    .malzeme-detay{
        li{
            margin-bottom: 7px
        }
    }
   
</style>
